(function () {
    "use strict";

    angular.module("app").component("requestRemarkFromSo", {
        template:
            `<div class="tab-panel bg-danger text-danger" ng-if="$ctrl.RemarkFound()">
                <habil-invalid-remark-view remark="$ctrl.GetRemark()"></habil-invalid-remark-view>
            </div>`,
        bindings: {
            allRemarks: "=",
            remarkName: "@",
        },
        controller: RequestRemarkFromSoController
    });

    RequestRemarkFromSoController.$inject = [];
    function RequestRemarkFromSoController() {
        const vm = this;

        vm.RemarkFound = remarkFound;
        vm.GetRemark = getRemark;

        function remarkFound() {
            if (!vm.allRemarks && !vm.remarkName)
                return false;

            const remark = _.find(vm.allRemarks, { SectionName: vm.remarkName });
            return (remark && remark.Remark);
        }

        function getRemark() {
            if (!vm.allRemarks && !vm.remarkName)
                return;

            const remark = _.find(vm.allRemarks, { SectionName: vm.remarkName });
            return remark.Remark;
        }
    };
})();
